import { createRouter, createWebHistory } from 'vue-router'
import { initKeycloak, isAuthenticated, login } from '../keycloak'

const routes = [
    { path: '/', name: 'landing', component: () => import('../views/LandingView.vue') },

    // Pagine pubbliche di contenuto: prerenderizzate in HTML statico al build
    // (vedi seo-routes.cjs + vue.config.js), quindi leggibili dai crawler senza JS.
    { path: '/guide', name: 'guide', component: () => import('../views/guide/GuideHubView.vue') },
    {
        path: '/guide/velocizzare-videolezioni-mercatorum',
        name: 'guide-mercatorum',
        component: () => import('../views/guide/VelocizzareMercatorumView.vue')
    },
    {
        path: '/guide/velocizzare-videolezioni-pegaso',
        name: 'guide-pegaso',
        component: () => import('../views/guide/VelocizzarePegasoView.vue')
    },
    {
        path: '/guide/autoplay-come-funziona',
        name: 'guide-autoplay',
        component: () => import('../views/guide/AutoplayComeFunzionaView.vue')
    },

    { path: '/app', name: 'finder', component: () => import('../views/FinderView.vue'), meta: { requiresAuth: true } },
    { path: '/:pathMatch(.*)*', redirect: '/' }
]

const router = createRouter({
    history: createWebHistory(),
    routes,
    scrollBehavior(to, from, savedPosition) {
        if (savedPosition) return savedPosition
        if (to.hash) return { el: to.hash, behavior: 'smooth' }
        return { top: 0 }
    }
})

router.beforeEach(async (to) => {
    if (!to.meta.requiresAuth) return true

    await initKeycloak()

    if (isAuthenticated()) return true

    login()
    return false
})

export default router
